// extracted by mini-css-extract-plugin
export default {"vehicleDropdown":"X7PrSRsRyR","halfWidth":"orUBIlXFPn"};